<template>
  <div class="text__container">
    <h2>CREDITS</h2>
    <!-- <prismic-rich-text v-for="cred in slice.items[0]" :key="cred.cred" :field="slice.cred"
    /> -->
    <p v-for="cred in slice.items" :key="cred.cred" :field="slice.cred">
      {{ cred.cred }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    slice: Object,
  },
};
</script>

<style lang="scss" scoped>
.text__container {
  color: white;
  margin: 100px 20vw;
  font-family: Lausanne, Helvetica, Arial, sans-serif;
  font-size: 28px;
  h2 {
    font-size: 16px;
    font-weight: normal;
    margin-bottom: 20px;
  }

  p {
    font-size: 28px;
  }
  @media screen and (max-width: 767px) {
    font-size: 22px;
    margin: 42px 20px;
    h2 {
      margin-bottom: 8px;
    }
    p {
      font-size: 22px;
    }
  }
}
</style>
